import { graphql } from "../../generated/gql";

// TEXT

// STYLES

// DATA
export const PROBE_QUERY = graphql(`
  query AuthRedirectProbe {
    __typename
  }
`);

// TYPES

// CONSTANTS
const ALLOWED_TO_HOST_SUFFIXES = [
  ".storybook.preview.studio.massivemusic.dev",
  ".storybook.studio.massivemusic.dev",
  ".storybook.studio.massivemusic.com",
];

// FUNCTIONS
/**
 * Prevent open-redirect abuse. Only allow redirection to HTTPS URLs on allowed host suffixes.
 * @see https://cwe.mitre.org/data/definitions/601.html
 */
export const isAllowedRedirect = (raw: string): boolean => {
  try {
    const url = new URL(raw);
    if (url.protocol !== "https:") return false;

    return ALLOWED_TO_HOST_SUFFIXES.some((suffix) =>
      url.hostname.endsWith(suffix),
    );
  } catch {
    return false;
  }
};

// ASSETS
